import { ActorType } from '../types/conversation.types';
import { MessageRole } from '../types/message.types';
export const createUserMessage = (content, conversationId, authorId = 'current-user') => ({
    conversation_id: conversationId,
    root_conversation_id: conversationId,
    content: content.trim(),
    role: MessageRole.USER,
    author_id: authorId,
    author_type: ActorType.CLIENT,
    timestamp: new Date().toISOString(),
});
export const createAssistantMessage = (content, conversationId, authorId = 'assistant') => ({
    conversation_id: conversationId,
    root_conversation_id: conversationId,
    content,
    role: MessageRole.ASSISTANT,
    author_id: authorId,
    author_type: ActorType.SYSTEM_PROCESS,
    timestamp: new Date().toISOString(),
});
export const validateMessageContent = (content) => {
    return content.trim().length > 0;
};
export const formatTimestamp = (timestamp) => {
    try {
        return new Date(timestamp).toLocaleTimeString();
    }
    catch (_a) {
        return '';
    }
};
export const groupMessagesByAuthor = (messages) => {
    if (messages.length === 0)
        return [];
    const groups = [];
    let currentGroup = [messages[0]];
    for (let i = 1; i < messages.length; i++) {
        const currentMessage = messages[i];
        const lastMessage = currentGroup[currentGroup.length - 1];
        if (currentMessage.author_type === lastMessage.author_type) {
            currentGroup.push(currentMessage);
        }
        else {
            groups.push(currentGroup);
            currentGroup = [currentMessage];
        }
    }
    groups.push(currentGroup);
    return groups;
};
const FUNDING_EXPLORER_ID_REGEX = /\/funding-explorer\/([0-9a-zA-Z-]+)\)/g;
export const extractCharlesIdentifiedGrantsIds = (message) => {
    if (!(message === null || message === void 0 ? void 0 : message.content))
        return [];
    FUNDING_EXPLORER_ID_REGEX.lastIndex = 0;
    const ids = new Set();
    for (const match of message.content.matchAll(FUNDING_EXPLORER_ID_REGEX)) {
        ids.add(match[1]);
    }
    return Array.from(ids);
};
